import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';


import {CONFIG_ENV} from '@/config';
import {slugify} from "@/module/utils";
import {I_List} from "@/types/iList";
import { date } from 'quasar';
import { scroll } from 'quasar';
const { getScrollTarget, setScrollPosition } = scroll;

@Component({components:{}})
export default class LastsPublicLists extends Vue {
    @Prop() listid!: number;
    @Prop() list_name_as_link!:string;
    nr_of_visible_images:number=0;
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    ajaxIsRunning:boolean=false;
    firstListFormAutoPlaySlider:string='first';
    widthImgCarousel:number=360;
    heightImgCarousel:number=270;


    columnsForDataTableGifts:Array<any>=[];

    last50PublicLists:Array<I_List>=[];

    $refs:any;
    constructor(){
        super();
        this.widthImgCarousel = Math.max(document.documentElement.clientWidth, window.innerWidth || 460)-100;
        this.heightImgCarousel = Math.max(document.documentElement.clientHeight, window.innerHeight || 540)/2;
        if(this.$q.platform.is.desktop) {this.nr_of_visible_images=3;} else{this.nr_of_visible_images=1;}
    }

    openAPublicList(plistid:I_List){
        this.$router.push({ name: 'view_public_list', params: { listid: plistid.listid.toString(),list_name_as_link:slugify(plistid.list_name),token_lista:plistid.token_pt_acces_lista } });
        const el: HTMLElement = document.getElementById('img_logo_site')!;
        const target = getScrollTarget(el)
        const offset = el.offsetTop
        const duration = 300;
        setScrollPosition(target, offset, duration);
    }

    goToPrevSlide(){
        this.$refs.mycarouselLists.goPrev();
    }
    goToNextSlide(){
        this.$refs.mycarouselLists.goNext();
    }

    async loadLast50PublicLists(){
        const vueInst=this;
        let res = await axios.get(`${CONFIG_ENV.URL_PUBLIC_INFO.get_last50_public_lists}`);
        let data = await res.data;
        vueInst.last50PublicLists=[];
        if(res.data.status=='success'){
            res.data.lists.forEach((plist:I_List)=>{
                let eventDate = date.buildDate({ year:plist.event_time.substr(0, 4),
                    month:plist.event_time.substr(5, 2),
                    date:plist.event_time.substr(8, 2),
                    hours:plist.event_time.substr(11, 2),
                    minutes:plist.event_time.substr(14, 2)
                });
                if(plist.has_attached_image=='y'){
                    vueInst.last50PublicLists.push({
                        userid:0,
                        listid:plist.listid,
                        list_name:plist.list_name,
                        name_of_titular_event:'',
                        type_of_event:0,
                        contact_phone:'',
                        event_time:plist.event_time,
                        event_time_data:date.formatDate(eventDate, 'DDMMM,YYYY'),
                        event_time_ora:date.formatDate(eventDate, 'HH:mm'),
                        privacy_type:'',
                        password_list:'',
                        description:'',
                        location_county:'',
                        location_city:plist.location_city,
                        location_street:plist.location_street,
                        location_text:plist.location_text,
                        type_of_titular_event:'',
                        status:'',
                        url_for_img:CONFIG_ENV.URL_LISTS.getImageAsAvatarForList+'/'+plist.listid,
                        has_attached_image:plist.has_attached_image,
                        token_pt_acces_lista:plist.token_pt_acces_lista
                    });
                }
            });
            if(vueInst.last50PublicLists.length>0){
                vueInst.firstListFormAutoPlaySlider=vueInst.last50PublicLists[1].listid.toString();
            }
        }
    }

    activated(){
        const vueInst=this;
            vueInst.last50PublicLists=[];
            vueInst.loadLast50PublicLists();
    }


}
